
var User_Id = $("#instafeed").data("user_id");
var Access_Token = $("#instafeed").data("access_token");
var limit = $("#instafeed").data("limit");

var userFeed = new Instafeed({
  get: 'user',
  userId: User_Id,
  accessToken: Access_Token,
  limit: limit,
  resolution: 'low_resolution',
     template: '<a href="{{link}}" class="insta_item" target="_blank"><div class="insta_img"><img src="{{image}}"/></div><div class="insta_overlay"><p><i class="fa fa-heart-o"></i>{{likes}}</p></div></a>'
  });

  userFeed.run();